import React from "react";
import Box from "ReusableComponents/Box";
import BlogImage from "assets/BlogImage.png";
import Text from "ReusableComponents/Text";

const InsightsBox = ({ small, data }) => {
  return (
    <Box
      position="relative"
      h={small ? "100%" : "95%"}
      w={small ? "95%" : "385px"}
      maxWidth={small ? "100%" : "385px"}
      background="#1A1A1A"
      margin="0 auto"
      onClick={() => (window.location.href = data?.link)}
      boxShadow="16px 16px 0px 0px #333333"
      overflow="hidden"
    >
      <Box>
        <img
          src={data?.featured_img?.data?.attributes?.url}
          alt="blogImage"
          style={{
            width: "385px",
            height: "225px",
            objectFit: "cover",
          }}
        />
        <Text
          fontSize={small ? "16px" : "23px"}
          fontWeight="bold"
          textColor="white"
          // margin="0"
          // style={{ maxWidth: small ? "80%" : "none" }}
        >
          {data.headline}
        </Text>
        {/* <Box
          display="flex"
          cursor="pointer"
          hoverBackground="#9CCDFB"
          w={small ? "auto" : "167px"}
          justifyContent="center"
          padding={small ? "8px 12px" : "0"}
          marginTop={small ? "16px" : "24px"}
          zIndex="2"
          position="absolute"
          background="#9CCDFB"
          left="24px"
          bottom="24px"
        ></Box> */}
      </Box>
    </Box>
  );
};

export default InsightsBox;
